import React from "react";
import { Grid, Button } from 'semantic-ui-react';
import { Accordion, Icon, List, Header } from 'semantic-ui-react'
import { getUserCache } from '../../../helpers/userCacheManager';
import setColor from '../../common/SetColor'
let userCache;

const alphabet = "abcdefghijklmnopqrstuvwxyz1234567890!@#$%^&*()-=_+[]{}\|;':,.<>/?`~`".split("");


class Storage extends React.Component {
    state = {
        activeIndex: 0,
        orgDataMap: new Map()
    }

    async componentDidMount() {
        this._asyncRequest = getUserCache(this.props.user._id).then(
            userCache => {
                this._asyncRequest = null;
                const orgDataMap = new Map();
                const organizations = this.props.organizations;
                if (organizations && userCache) {
                    organizations.forEach(function (org) {
                        orgDataMap.set(org.id, {
                            teams: [],
                            initiatives: [],
                            playBooks: [],
                            contents: [],
                            invites: [],
                            accountUsers: []
                        });
                        if (userCache.hasVertex(org.id)) {
                            const orgEdges = userCache.outEdges(org.id);
                            if (orgEdges) {
                                const orgEdgesArray = Array.from(orgEdges);
                                const orgStats = {
                                    teams: [...orgEdgesArray.filter(({ target, type }) => target.type === 'Team' && type === "owns")],
                                    initiatives: [...orgEdgesArray.filter(({ target }) => target.type === 'Initiative')],
                                    playBooks: [...orgEdgesArray.filter(({ target }) => target.type === 'Playbook')],
                                    contents: [...orgEdgesArray.filter(({ target }) => target.type === 'Content')],
                                    invites: [...orgEdgesArray.filter(({ target }) => target.type === 'Invite')],
                                    accountUsers: [...orgEdgesArray.filter(({ target }) => target.type === 'AccountUser')]
                                }
                                orgDataMap.set(org.id, orgStats);
                            }
                        }
                    });
                }
                this.setState({ orgDataMap });
            }
        );


    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    closeDock() {
        this.props.handleStorageVisibleChange(false)
    }

    render() {

        const { activeIndex, orgDataMap } = this.state
        let windowHeight = window.innerHeight;
        return (
            <React.Fragment>
                <h4 className="pane_header">
                    Storage
            <Icon name="close" className="closeIcon" onClick={() => this.closeDock()} />
                </h4>
                <Grid className="settingPane w_100" style={{ maxHeight: windowHeight - 52, overflow: "auto" }}>
                    <Grid.Row columns={1}>
                        <Grid.Column>

                            <Accordion styled fluid>
                                {this.props.organizations && this.props.organizations.map((item, i) => {
                                    let team = orgDataMap.get(item.id) ? orgDataMap.get(item.id).teams : [];
                                    let playbook = orgDataMap.get(item.id) ? orgDataMap.get(item.id).playBooks : [];
                                    let initiative = orgDataMap.get(item.id) ? orgDataMap.get(item.id).initiatives : [];
                                    let content = orgDataMap.get(item.id) ? orgDataMap.get(item.id).contents : [];
                                    let invite = orgDataMap.get(item.id) ? orgDataMap.get(item.id).invites : [];
                                    let accountUser = orgDataMap.get(item.id) ? orgDataMap.get(item.id).accountUsers : [];
                                    return (
                                        <div key={i}>
                                            <Accordion.Title
                                                active={activeIndex === i}
                                                index={i}
                                                onClick={this.handleClick}
                                            >
                                                <Icon name='dropdown' />
                                                {item.name}
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === i}>
                                                <Header as='h4'>Account User ({accountUser && accountUser.length})</Header>
                                                <List bulleted >
                                                    {accountUser && accountUser.length !== 0 ?
                                                        accountUser.map((item1, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item1.target.props.name}
                                                                </List.Item>
                                                            )
                                                        })
                                                        : <span className="clr-gray" >No AccountUser Available</span>
                                                    }
                                                </List>
                                                <Header as='h4'>Invite ({invite && invite.length})</Header>
                                                <List bulleted >
                                                    {invite && invite.length !== 0 ?
                                                        invite.map((item1, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item1.target.props.firstName} {item1.target.props.lastName}
                                                                </List.Item>
                                                            )
                                                        })
                                                        : <span className="clr-gray" >No Invite Available</span>
                                                    }
                                                </List>
                                                <Header as='h4'>Teams ({team && team.length})</Header>
                                                <List bulleted >
                                                    {team && team.length !== 0 ?
                                                        team.map((item1, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item1.target.props.name}
                                                                </List.Item>
                                                            )
                                                        })
                                                        : <span className="clr-gray" >No Team Available</span>
                                                    }
                                                </List>
                                                <Header as='h4'>Playbook ({playbook && playbook.length})</Header>
                                                <List bulleted >
                                                    {playbook && playbook.length !== 0 ?
                                                        playbook.map((item2, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item2.target.props.name}
                                                                </List.Item>
                                                            )
                                                        }) :
                                                        <span className="clr-gray" >No Playbook Available</span>
                                                    }
                                                </List>
                                                <Header as='h4'>Initiative ({initiative && initiative.length})</Header>
                                                <List bulleted >
                                                    {initiative && initiative.length !== 0 ?
                                                        initiative.map((item3, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item3.target.props.name}
                                                                </List.Item>
                                                            )
                                                        }) :
                                                        <span className="clr-gray" >No Initiative Available</span>
                                                    }
                                                </List>
                                                <Header as='h4'>Content ({content && content.length})</Header>
                                                <List bulleted >
                                                    {content && content.length !== 0 ?
                                                        content.map((item4, i) => {
                                                            return (
                                                                <List.Item key={i}>
                                                                    {item4.target.props.name}
                                                                </List.Item>
                                                            )
                                                        }) :
                                                        <span className="clr-gray" >No Content Available</span>
                                                    }
                                                </List>
                                            </Accordion.Content>
                                        </div>
                                    )
                                })}
                                <Accordion.Title
                                    active={activeIndex === 100}
                                    index={100}
                                    onClick={this.handleClick}
                                >
                                    <Icon name='dropdown' />
                                    Colors
                                </Accordion.Title>
                                <Accordion.Content active={activeIndex === 100} >
                                    <div style={{ display: "flow-root" }}>
                                        {alphabet && alphabet.length !== 0 ?
                                            alphabet.map((alp, i) => {
                                                return (
                                                    <div key={i} style={{
                                                        background: setColor(alp.toUpperCase()), width: "30px",
                                                        height: "30px",
                                                        textAlign: "center",
                                                        padding: "6px 0",
                                                        display: "block",
                                                        color: "white",
                                                        float: "left",
                                                        margin: "5px",
                                                        fontSize: "18px"
                                                    }}>
                                                        <strong>{alp.toUpperCase()}</strong>
                                                    </div>
                                                )
                                            }) :
                                            <span className="clr-gray" >No content Available</span>
                                        }
                                    </div>
                                </Accordion.Content>
                            </Accordion>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        );
    }
}
export default Storage;
